module.exports = __webpack_public_path__ + "img/7aa4815.jpg";